import { render, staticRenderFns } from "./User.Details.vue?vue&type=template&id=63688370&scoped=true&"
import script from "./User.Details.vue?vue&type=script&lang=js&"
export * from "./User.Details.vue?vue&type=script&lang=js&"
import style0 from "./User.Details.vue?vue&type=style&index=0&id=63688370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63688370",
  null
  
)

export default component.exports